import React from 'react';
import { Snackbar, Alert, Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import LockIcon from '@mui/icons-material/Lock';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';

const PopupNotification = ({ open, onClose, type, data }) => {
  const getNotificationContent = () => {
    switch (type) {
      case 'NEW_ORDER':
        return {
          icon: <CheckCircleIcon />,
          color: 'success',
          title: 'Order Placed Successfully',
          message: `${data?.order_side} ${data?.quantity} ${data?.symbol} @ ₹${data?.price}`
        };
      case 'MODIFY_ORDER':
        return {
          icon: <EditIcon />,
          color: 'info',
          title: 'Order Modified Successfully',
          message: `Modified: ${data?.quantity} qty @ ₹${data?.price}`
        };
      case 'CANCEL_ORDER':
        return {
          icon: <CancelIcon />,
          color: 'warning',
          title: 'Order Cancelled Successfully',
          message: `Cancelled order #${data?.order_id}`
        };
      case 'ERROR':
        return {
          icon: <ErrorIcon />,
          color: 'error',
          title: 'Error',
          message: data?.message || 'Something went wrong'
        };
      case 'SESSION_EXPIRED':
        return {
          icon: <LockIcon />,
          color: 'error',
          title: 'Session Expired',
          message: data?.message || 'Your session has expired. Please login again.'
        };
      case 'SUCCESS':
        return {
          icon: <CheckCircleIcon />,
          color: 'success',
          title: 'Success',
          message: data?.message
        };
      case 'NEW_INSTRUMENT':
        return {
          icon: <AddCircleIcon />,
          color: 'success',
          title: 'Instrument Added',
          message: `${data?.symbol} added to marketwatch`
        };
      case 'DELETE_INSTRUMENT':
        return {
          icon: <DeleteIcon />,
          color: 'success',
          title: 'Instrument Removed',
          message: `${data?.symbol} removed from marketwatch`
        };
      default:
        return null;
    }
  };

  const content = getNotificationContent();
  if (!content) return null;

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{
        marginTop: '64px', // Height of AppBar
        '& .MuiSnackbar-root': {
          top: '64px'
        }
      }}
    >
      <Alert
        severity={content.color}
        onClose={onClose}
        sx={{ 
          width: '100%', 
          minWidth: '300px',
          boxShadow: 3
        }}
        icon={content.icon}
      >
        <Box>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
            {content.title}
          </Typography>
          <Typography variant="body2">
            {content.message}
          </Typography>
        </Box>
      </Alert>
    </Snackbar>
  );
};

export default PopupNotification; 